import * as tips from './tips';
import * as api from './api';
import * as utils from './utils';
import * as share from './share';

const getLoginStatus = isClean => {
  return new Promise(resolve => {
    FB.getLoginStatus(response => {
      resolve(response.status === 'connected');
    }, isClean);
  });
};

const fbLogin = () => {
  return new Promise(resolve => {
    FB.login(function (response) {
      resolve(response.status === 'connected');
    });
  });
};

const excShare = info => {
  return new Promise(resolve => {
    FB.ui(info, function (res) {
      resolve(res && !res.error_message);
    });
  });
};
export const fbShare = async () => {
  let shareUrl = `https://${api.EVENT_HOST}/${api.AID}/index.html?aid=${api.AID}&cid=share&scid=fb`;
  let picUrl = `https://${api.EVENT_HOST}/${api.AID}/img/share.jpg?v=1`;
  let info = {
    method: 'share',
    href: `https://${
      api.API_HOST
    }/fbShareCustomize/customizeShare/message/${encodeURIComponent(
      tips.shareInfo.descript
    )}/app_id/1153445821668215/share_title/${encodeURIComponent(
      tips.shareInfo.title
    )}/redict_url/${encodeURIComponent(shareUrl)}/pic_url/${encodeURIComponent(
      picUrl
    )}`,
    display: 'popup',
  };
  if (utils.isFBAndroid) {
    info.href = encodeURIComponent(info.href);
  }
  let checkRes = await getLoginStatus();
  if (!checkRes) {
    await fbLogin();
  }
  await excShare(info);
  await utils.sleep(1);
  await share.shareCb();
};
